import yup from '../../../config/yup';

export const excelReadValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('excel'),
  properties: yup.object().shape({
    worksheets: yup.string(),
    useHeader: yup.boolean(),
    treatEmptyValuesAsNulls: yup.boolean(),
    inferSchema: yup.boolean(),
    addColorColumns: yup.boolean(),
    startColumn: yup.string(),
    endColumn: yup.string(),
    timestampFormat: yup.string(),
    excerptSize: yup.string(),
  }),
});

export const excelReadFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Excel ID',
    },
    '@data-type': {
      type: 'string',
      title: 'Data Type',
      default: 'format',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'excel',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        worksheets: {
          type: 'string',
          title: 'Worksheets',
        },
        useHeader: {
          type: 'boolean',
          title: 'Use Header',
        },
        treatEmptyValuesAsNulls: {
          type: 'boolean',
          title: 'Treat Empty Values As Nulls',
        },
        inferSchema: {
          type: 'boolean',
          title: 'Infer Schema',
        },
        addColorColumns: {
          type: 'boolean',
          title: 'Add Color Columns',
        },
        startColumn: {
          type: 'string',
          title: 'Start Column',
        },
        endColumn: {
          type: 'string',
          title: 'End Column',
        },
        timestampFormat: {
          type: 'string',
          title: 'Timestamp Format',
        },
        excerptSize: {
          type: 'string',
          title: 'Excerpt Size',
        },
      },
    },
  },
  required: ['@id', '@data-type', 'name', 'type'],
};
export const excelReadFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated after saving',
  },
  '@data-type': {
    'ui:readonly': true,
  },
  type: {
    'ui:readonly': true,
  },
  useHeader: {
    'ui:widget': 'checkbox',
  },
  treatEmptyValuesAsNulls: {
    'ui:widget': 'checkbox',
  },
  inferSchema: {
    'ui:widget': 'checkbox',
  },
  addColorColumns: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};

export const excelWriteValidationSchema = yup.object().shape({
  '@id': yup.string(),
  '@data-type': yup.string().default('format'),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('excel'),
  properties: yup.object().shape({
    worksheets: yup.string(),
    useHeader: yup.boolean(),
  }),
});

export const excelWriteFormSchema = {
  type: 'object',
  properties: {
    '@id': {
      type: 'string',
      title: 'Format ID',
    },
    name: {
      type: 'string',
      title: 'Name',
      pattern: '^[a-zA-Z_$][a-zA-Z0-9_$]*$',
    },
    type: {
      type: 'string',
      title: 'Type',
      default: 'excel',
    },
    properties: {
      type: 'object',
      title: 'Properties',
      properties: {
        worksheets: {
          type: 'string',
          title: 'Worksheets',
        },
        useHeader: {
          type: 'boolean',
          title: 'Use Header',
        },
      },
    },
  },
  required: ['name', 'type'],
};

export const excelWriteFormUiSchema = {
  '@id': {
    'ui:readonly': true,
    'ui:placeholder': 'Auto generated',
  },
  type: {
    'ui:readonly': true,
  },
  useHeader: {
    'ui:widget': 'checkbox',
  },
  'ui:submitButtonOptions': {
    props: {
      disabled: false,
      className: 'btn btn-primary',
    },
    norender: false,
    submitText: 'Save',
  },
};
